// TODO: Extract to a shared location — duplicated from `@/react/components/PostsCompass`.
import { useThemeContext } from "@/react/providers/Theme";

interface EmojiRecord {
  custom_emoji_dark_url?: string;
  custom_emoji_url?: string;
  emoji?: string;
}

type EmojiProps =
  | { emoji: string; emojiUrl?: never }
  | { emojiUrl: string; emoji?: never }
  | { emoji?: never; emojiUrl?: never };

export const useEmoji = (record: EmojiRecord): EmojiProps => {
  const { isDarkAppearance } = useThemeContext();

  const emojiUrl = isDarkAppearance
    ? record.custom_emoji_dark_url || record.custom_emoji_url
    : record.custom_emoji_url || record.custom_emoji_dark_url;

  if (emojiUrl) return { emojiUrl };

  if (record.emoji) return { emoji: record.emoji };

  return {};
};
